(($) => {

  let virtualTours = {
    titleCache: {},

    firePageView(href, title) {
      if (typeof dataLayer !== 'undefined') {
        (function () {
          dataLayer.push(arguments);
        })('event', 'page_view', {
          page_location: href,
          page_path:     href,
          page_title:    title
        });
      }

      if (typeof Jonahlytics !== 'undefined') {
        Jonahlytics.event.pageView(href.replace(window.location.origin, '', href));
      }
    },

    ready: function () {
      $('[data-vt-embed]').attr('data-type', 'iframe').fancybox({
        idleTime:         60,
        loop:             true,
        transitionEffect: "slide",

        buttons: [
          "close"
        ],

        wheel: false,

        afterLoad: (instance, current) => {
          let $trigger = current.opts.$orig;

          if (typeof Jonahlytics !== 'undefined') {
            Jonahlytics.event.virtualTour($trigger.data('src'));
          }

          if ($trigger && $trigger.length && $trigger.attr('rel') !== 'nofollow') {
            let virtualTourSinglePageURL = new URL(window.location.origin + $trigger.attr('href'));

            if (this.titleCache[virtualTourSinglePageURL]) {
              this.firePageView(virtualTourSinglePageURL.href, this.titleCache[virtualTourSinglePageURL]);
            } else {
              $.get(virtualTourSinglePageURL.href, (html) => {
                this.titleCache[virtualTourSinglePageURL] = $(html).filter('title').text();
                this.firePageView(virtualTourSinglePageURL.href, this.titleCache[virtualTourSinglePageURL]);
              });
            }
          }
        }
      });
    }
  }

  $(() => virtualTours.ready());

})(jQuery);
